export const baseAcctUrl = process.env.NEXT_PUBLIC_LOGIN_URL?.replace(
  /\/log-in\/?$/,
  '',
);
export const accountUrl = `${baseAcctUrl}/account/dashboard`;
